import { createContext, useContext, useState } from "react";

const UserContext = createContext();

export const AuthContextProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem('token'));
    const userIsLoggedIn = !!token && JSON.parse(localStorage.getItem('registered'));

    const loginHandler = (token, refreshToken) => {
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
        setToken(token);
    };

    return (
        <UserContext.Provider
            value={{
                login: loginHandler,
                isLoggedIn: userIsLoggedIn,
                token
            }}>
            {children}
        </UserContext.Provider>
    );
};

export const useAuthContext = () => useContext(UserContext);